import Vue from 'vue'
import App from './App.vue'
import router from './router.js'
import axios from 'axios'
import Rollbar from 'rollbar'

// import axiosRetry from 'axios-retry'
import store from './store.js'

import vuetify from './plugins/vuetify';


function initGosubs() {
  Vue.config.productionTip = false
 //  axiosRetry(axios, { retries: 3 })
  Vue.prototype.$axios = axios.create({
    headers: { 'Subs-Key': process.env.VUE_APP_API_TOKEN }
  });
  Vue.prototype.$displayTopMessage = (message, mode = 'success') => {
    if (typeof window.displayTopMessage === 'function') {
      window.displayTopMessage(message, mode)
    }
  }

  Vue.prototype.$rollbar = new Rollbar({
    accessToken: 'ad028c179b0d4548b09dbd25c1169a4b',
    captureUncaught: true,
    captureUnhandledRejections: true,
  })
  Vue.config.errorHandler = (err, vm) => {
    vm.$rollbar.error(err);
    throw err; // rethrow
  };

  new Vue({
    router,
    render: h => h(App),
    vuetify,
    store
  }).$mount('#app')
}


window.initGosubs = initGosubs;